import { useTracking } from '@change-corgi/core-react/tracking';

import { useTopicPageData } from '#src/app/pages/topic/details/pageContext';

type Result = ModelHookResult<{
	name: string;
	hasTopicPhoto: boolean;
	trackSAP: () => void;
}>;

export function usePageHeading(): Result {
	const {
		data: { name, photos },
	} = useTopicPageData();

	const track = useTracking();

	const photo = photos.length ? photos[0] : undefined;
	const hasTopicPhoto = !!(photo?.heroMedium.url && photo.metadata?.credit && photo.metadata.source);

	return {
		data: {
			name,
			hasTopicPhoto,
			trackSAP: () => {
				void track('topic_sap_click_top');
			},
		},
	};
}
